import CoverImage from './cover-image'

export type { CoverImageProps } from './cover-image'

export default CoverImage
